import removeCommas from "./removeCommas";

// add commas to a number (number can be of type string or a number)
const addCommas = (num: string | number): string => {
  const numStr = removeCommas(`${num}`);

  // remove leading 0s if the string has a length > 1, ex: 01 -> 1
  if (numStr.length > 1 && numStr.startsWith("0")) {
    return addCommas(numStr.slice(1));
  }

  // if the string is not a number, just return the string as is (don't try any formatting)
  if (isNaN(Number(numStr))) {
    return numStr;
  }

  // logic to add commas to the number string
  const numStrParts = numStr.split(".");
  const decimalPart = numStrParts[1] !== undefined ? `.${numStrParts[1]}` : "";

  const reversedNumCharArr = numStrParts[0].split("").reverse();
  const result = reversedNumCharArr.reduce((acc, cur, i) => {
    const newAcc = `${cur}${acc}`;
    if (i === reversedNumCharArr.length - 1) {
      return newAcc;
    }

    return (i + 1) % 3 === 0 ? `,${newAcc}` : newAcc;
  }, "");

  return `${result}${decimalPart}`;
};

export default addCommas;
